/* eslint-disable no-use-before-define */
import React, { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Checkbox } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import stylisRTLPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
interface test {
  items: any;
  label: any;
  placeholder: any;
  selectAllLabel: any;
  noOptionsText?: any;
  limitTags: any;
  onChange: any;
  valueSupplier: any;
}

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiAutocomplete-endAdornment": {
      // top: "calc(50% - 21px)",
      position: "initial",
    },
    "& .MuiAutocomplete-inputRoot .MuiAutocomplete-input": {
      width: "0",
      right: "0px",
      position: "relative",
      minWidth: "0px",
    },
    "& .MuiAutocomplete-inputRoot": {
      overflow: "hidden !important",
      flexWrap: "nowrap !important",
      textOverflow: "ellipsis !important",
      whiteSpace: "nowrap  !important",
      position: "initial",
      color: "#fff",
    },
  },
}));

const MultiSelect = ({
  items,
  label,
  placeholder,
  selectAllLabel,
  noOptionsText,
  limitTags,
  onChange,
  valueSupplier,
}: test) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const allSelected = items.length === selectedOptions.length;
  const handleToggleOption = (selectedOptions: any) =>
    setSelectedOptions(selectedOptions);
  const handleClearOptions = () => setSelectedOptions([]);
  const getOptionLabel = (option: any) => `${option.title}`;
  const handleSelectAll = (isSelected: any) => {
    if (isSelected) {
      setSelectedOptions(items);
    } else {
      handleClearOptions();
    }
  };

  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected);
  };
  const theme = createTheme({
    direction: "rtl", // Both here and <body dir="rtl">
  });
  // Create rtl cache
  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [stylisRTLPlugin],
  });
  const handleChange = (event: any, selectedOptions: any, reason: any) => {
    if (reason === "select-option" || reason === "remove-option") {
      if (selectedOptions.find((option: any) => option.id === "select-all")) {
        handleToggleSelectAll();
        let result = [];
        result = items.filter((el: any) => el.id !== "select-all");
        return onChange(result);
      } else {
        handleToggleOption && handleToggleOption(selectedOptions);
        return onChange(selectedOptions);
      }
    } else if (reason === "clear") {
      handleClearOptions && handleClearOptions();
    }
  };

  const optionRenderer = (option: any, { selected }: { selected: any }) => {
    const selectAllProps =
      option.id === "select-all" // To control the state of 'select-all' checkbox
        ? { checked: allSelected }
        : {};
    return (
      <>
        <Checkbox
          color="primary"
          icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
          checkedIcon={<CheckBoxIcon fontSize="small" />}
          style={{ marginRight: 8 }}
          checked={selected}
          {...selectAllProps}
        />
        {getOptionLabel(option)}
      </>
    );
  };
  const jsonFile = useSelector((state: any) => state.style);

  const inputRenderer = (params: any) => (
    <TextField
      {...params}
      label={label}
      // placeholder={placeholder}
      variant="outlined"
      color={jsonFile?.muiColor}
    />
  );
  const classes = useStyles();
  const getOptionSelected = (option: any, anotherOption: any) =>
    option.id === anotherOption.id;

  useEffect(() => {
    if (valueSupplier.length > 0) {
      if (valueSupplier!.find((option: any) => option?.id! === "select-all")) {
        handleToggleSelectAll();
        let result = [];
        result = items.filter((el: any) => el.id !== "select-all");
        return onChange(result);
      } else {
        handleToggleOption && handleToggleOption(valueSupplier);
        return onChange(valueSupplier);
      }
    }
  }, []);

  const filter = createFilterOptions();
  return (
    // <CacheProvider value={cacheRtl}>
    //   <div style={{ direction: "rtl" }} >
    <Autocomplete
      classes={classes}
      multiple
      size="small"
      limitTags={limitTags}
      options={items}
      value={selectedOptions}
      disableCloseOnSelect
      getOptionLabel={getOptionLabel}
      getOptionSelected={getOptionSelected}
      noOptionsText={noOptionsText}
      filterOptions={(options: any, params: any) => {
        const filtered = filter(options, params);
        return [{ title: selectAllLabel, id: "select-all" }, ...filtered];
      }}
      onChange={handleChange}
      renderOption={optionRenderer}
      renderInput={inputRenderer}
      id="tags-outlined"
      disablePortal={true}
    />
    //   </div>
    // </CacheProvider>
  );
};

MultiSelect.defaultProps = {
  limitTags: 2,
  items: [],
  selectedValues: [],
  getOptionLabel: (id: any) => id,
};

export default MultiSelect;
